import type { ApiError } from '@/shared/api';

/**
 * Meldet Channex die Ressource als fehlend, ist die Bindung des Apartments veraltet. Reparieren
 * lässt sich das nur über die Veröffentlichung des Objekts — es gibt keine apartmentbezogene
 * Sofort-Aktion mehr, und eine anzubieten wäre ein Knopf ohne Wirkung.
 */
export const MISSING_AT_CHANNEX =
  'Channex kennt Zimmer oder Rate nicht — die Veröffentlichung des Objekts ist veraltet.';

export const NOT_ROUTABLE =
  'Dieses Apartment ist beim Kanalmanager nicht zustellbar — erst veröffentlichen, dann pushen.';

/**
 * Die Codes stammen aus `ChannexPropertyResolver`: er lehnt einen Push ab, solange Unit oder
 * Objekt nicht bestätigt und aktuell sind. Ohne diese Liste fällt die Anzeige auf den
 * englischen Servertext zurück.
 */
const NOT_ROUTABLE_CODES = [
  'channex_unit_not_published',
  'channex_unit_publish_failed',
  'channex_unit_reconcile_required',
  'channex_unit_not_current',
  'channex_parent_publish_failed',
  'channex_parent_reconcile_required',
  'channex_parent_not_current',
  'channex_binding_topology_invalid',
];

export function isNotRoutable(error: ApiError): boolean {
  const haystack = `${error.title ?? ''} ${error.detail ?? ''}`.toLowerCase();
  return NOT_ROUTABLE_CODES.some((code) => haystack.includes(code));
}

export function isMissingAtChannex(error: ApiError): boolean {
  const detail = (error.detail ?? '').toLowerCase();
  return (
    error.status === 404 ||
    detail.includes('not found') ||
    detail.includes('channex_rate_plan_missing')
  );
}
